export default "/images/nomination2.jpg?169baf8827537e7ecea4fac488ab61c1";